<!-- @format -->

<ng-container *transloco="let t">
  @if (options$ | async; as options) {
    @if (studyRightCount() === 0) {
      <p class="app-widget-container__content__info-text sis-mb-sm">
        {{ t("FRONTPAGE.SELECT_PLAN_DROPDOWN.NO_STUDY_RIGHTS") }}
      </p>
    }
    @if (studyRightCount() > 0 && options.length === 0) {
      <p class="app-widget-container__content__info-text sis-mb-sm">
        {{ t("FRONTPAGE.SELECT_PLAN_DROPDOWN.PLAN_MISSING") }}
      </p>
    }
    @if (searchFailed()) {
      <p class="app-widget-container__content__info-text sis-mb-sm">
        {{ t("FRONTPAGE.SELECT_PLAN_DROPDOWN.FETCHING_PLANS_FAILED") }}
      </p>
    }
    @if (options.length > 0) {
      <label for="select-plan" class="mb-2">{{ t("FRONTPAGE.SELECT_PLAN_DROPDOWN.EDUCATION") }}</label>
    }
    <!-- This is two because header is count as one -->
    @if (options.length === 2) {
      <p class="app-widget-container__content__info-text sis-mb-sm">
        {{ options[1].label }}
      </p>
    }
    @if (options.length > 2) {
      <sis-dropdown-select (selectionChange)="onSelect($event)" id="select-plan" [options]="options" [selection]="selection()" />
    }
  } @else {
    <div aria-busy="true" class="d-flex justify-content-center pt-3">
      <sis-small-spinner />
    </div>
  }
</ng-container>
